import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import { auth } from "@/firebase";
import store from "./store";

Vue.use(Router);

const router = new Router({
  mode: process.env.CORDOVA_PLATFORM ? "hash" : "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "*",
      redirect: "/",
    },
    {
      path: "/",
      redirect: "/home",
    },
    {
      path: "/login",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Login.vue"),
    },
    {
      path: "/sign-up",
      name: "SignUp",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/SignUp.vue"),
    },
    {
      path: "/home",
      name: "home",
      component: Home,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/perfil",
      name: "perfil",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Perfil.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/temas",
      name: "temas",
      meta: {
        requiresAuth: true,
      },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "tareas" */ "./views/Temas.vue"),
    },
    {
      path: "/tests",
      name: "tests",
      meta: {
        requiresAuth: true,
      },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "tareas" */ "./views/Tests.vue"),
    },
    
   
    // {
    //   path: "/preguntas/:id",
    //   name: "preguntas",
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () =>
    //     import(/* webpackChunkName: "preguntas" */ "./views/Preguntas.vue")
    // },
    {
      path: "/preguntas/",
      name: "preguntas",
      props: true,
      meta: {
        requiresAuth: true,
      },

      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "preguntas" */ "./views/Preguntas.vue"),
    },
    {
      path: "/examen/",
      name: "examen",
      props: true,
      meta: {
        requiresAuth: true,
      },

      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "preguntas" */ "./views/Examen.vue"),
    },
    {
      path: "/examen2/",
      name: "examen2",
      props: true,
      meta: {
        requiresAuth: true,
      },

      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "preguntas" */ "./views/Examen2.vue"),
    },
    {
      path: "/reportes/",
      name: "reportes",
      props: true,
      meta: {
        requiresAuth: true,
      },

      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "preguntas" */ "./views/Reportes.vue"),
    },
  ],
});

router.beforeEach((to, from, next) => {
  const user = auth.currentUser;

  console.log("from")
  console.log(from)
  
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (user != null) {
      console.log("dentro if router");
      next();
    } else {
      console.log("dentro if router en ELSE");

      next({ name: "login" });
    }
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;
